import React, { useRef, useState } from 'react';
import {
  Box,
  Typography,
  Stack,
  Card,
  CardContent,
  Button,
  Divider,
} from '@mui/material';
import { useTreeViewApiRef, RichTreeView } from '@mui/x-tree-view';

export const FilterComponent = ({
  data = [],
  selectedFiltersList = [],
  setSelectedFiltersList = () => {},
  setIsFiltersModalOpen = () => {},
}) => {
  const transformData = (data) => {
    return data.map((item) => {
      const { value, ...rest } = item;
      return {
        ...rest,
        children: transformData(value),
      };
    });
  };
  const defaultExpandedItems = new Set();
  selectedFiltersList.forEach((item) => {
    const tempArr = item.split('|');
    for (let i = 0; i < tempArr.length; i++) {
      const path = tempArr.slice(0, i + 1).join('|');
      defaultExpandedItems.add(path);
    }
  });

  const transformedData = transformData(data);
  const [selectedItems, setSelectedItems] = useState(selectedFiltersList);
  const toggledItemRef = useRef({});
  const apiRef = useTreeViewApiRef();

  const handleItemSelectionToggle = (event, itemId, isSelected) => {
    toggledItemRef.current[itemId] = isSelected;
  };
  function getItemDescendantsIds(item) {
    const ids = [];
    item.children?.forEach((child) => {
      ids.push(child.id);
      ids.push(...getItemDescendantsIds(child));
    });

    return ids;
  }
  const handleSelectedItemsChange = (event, newSelectedItems) => {
    setSelectedItems(newSelectedItems);

    // Select / unselect the children of the toggled item
    const itemsToSelect = [];
    const itemsToUnSelect = {};
    Object.entries(toggledItemRef.current).forEach(([itemId, isSelected]) => {
      const item = apiRef.current.getItem(itemId);
      if (isSelected) {
        itemsToSelect.push(...getItemDescendantsIds(item));
      } else {
        getItemDescendantsIds(item).forEach((descendantId) => {
          itemsToUnSelect[descendantId] = true;
        });
      }
    });

    const newSelectedItemsWithChildren = Array.from(
      new Set(
        [...newSelectedItems, ...itemsToSelect].filter(
          (itemId) => !itemsToUnSelect[itemId],
        ),
      ),
    );

    setSelectedItems(newSelectedItemsWithChildren);

    toggledItemRef.current = {};
  };

  const handleApplyFilters = () => {
    setSelectedFiltersList(selectedItems);
    setIsFiltersModalOpen(false);
  };

  const handleClearFilters = () => {
    setSelectedFiltersList([]);
    setIsFiltersModalOpen(false);
  };

  return (
    <Card
      sx={{
        backgroundColor: '#FFFFFF',
        color: '#1C252E',
        transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        borderRadius: '16px',
        boxShadow:
          '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
        backgroundImage: 'none',
        overflow: 'hidden',
        position: 'relative',
        zIndex: 0,
        overflowY: 'scroll',
        height: '100vh',
      }}
    >
      <CardContent>
        <Typography variant={'h5'}>Product Category Filters</Typography>
        <Divider sx={{ m: 2 }} />

        <RichTreeView
          multiSelect
          checkboxSelection
          apiRef={apiRef}
          items={transformedData}
          selectedItems={selectedItems}
          onSelectedItemsChange={handleSelectedItemsChange}
          onItemSelectionToggle={handleItemSelectionToggle}
          defaultExpandedItems={[...defaultExpandedItems]}
        />

        <Divider sx={{ m: 2 }} />
        <Stack
          direction='row'
          spacing={2}
        >
          <Button
            variant='contained'
            color='primary'
            onClick={handleApplyFilters}
          >
            Apply Filters
          </Button>
          <Button
            variant='contained'
            color='error'
            onClick={handleClearFilters}
          >
            Clear All Filters
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
